import React, { useState, useEffect } from "react";
//import { makeStyles,useTheme } from "@material-ui/core/styles";
import {
  Select,
  MenuItem,
  Grid,
  Typography,
  FormControl,
  InputLabel,
  FormHelperText
} from "@material-ui/core";

import { keyToLabel } from "../../../functions/GlobalHelpers"
import InfoTooltip from "../../general/InfoTooltip";
// const useStyles = makeStyles((theme) => ({

// })); 

export default function CreditSelectField(
  {
    fieldConfig,
    currentMetafields,
    hideChannels = false,
    channelDisplayNames,
    setMetafieldsValues,
    resolvePlaceholders,
    labelPosition = "floating"
  }) {
  // const theme = useTheme();
  // const classes = useStyles();
  const [value, setValue] = useState(null);

  useEffect(() => {
    let externalValue = getExternalValue();
    if (fieldConfig.multiple) {
      // compare arrays to avoid rerendering
      if (JSON.stringify(externalValue) !== JSON.stringify(value))
        setValue(externalValue);

    } else {
      // console.log("new externalValue: ", externalValue);
      if (externalValue !== value)
        setValue(externalValue);
    }
  }, [currentMetafields]);

  useEffect(() => {
    if (value !== null) {
      const externalValue = getExternalValue();
      if (fieldConfig.multiple) {
        if (JSON.stringify(externalValue) !== JSON.stringify(value)) {
          // console.log("setMetafieldsValues: ", value);
          setMetafieldsValues(currentMetafields, JSON.stringify(value));
        }
      } else {
        if (externalValue !== value) {
          // console.log("setMetafieldsValues: ", value);
          setMetafieldsValues(currentMetafields, value);
        }
      }
    }
  }, [value]);


  const isExternalValueAValidOption = (externalValue) => {
    return (undefined !== fieldConfig.options.find((option) => {
      if (typeof option === "string" || !isNaN(option)) {
        if (fieldConfig.field_type === "INT_ENUM")
          return parseInt(option) === parseInt(externalValue);
        else
          return option === externalValue;
      } else {
        if (fieldConfig.field_type === "INT_ENUM")
          return parseInt(option.value) === parseInt(externalValue);
        else
          return option.value === externalValue;
      }
    }));
  }

  const getExternalValue = () => {
    if (fieldConfig.multiple) {
      let externalValue = currentMetafields[0].meta_value;
      if (!externalValue) {
        externalValue = [];
      } else {
        // parse json string to array
        externalValue = JSON.parse(externalValue);;
      }

      if (fieldConfig.field_type === "INT_ENUM") {
        externalValue = externalValue.map((value) => parseInt(value));
      }

      // remove values that are not in options
      return externalValue.filter((value) => isExternalValueAValidOption(value));
    } else {
      let externalValue = fieldConfig.field_type === "INT_ENUM"
        ? (
          currentMetafields[0].meta_value_numeric || currentMetafields[0].meta_value_numeric === 0
            ? currentMetafields[0].meta_value_numeric
            : ""
        )
        : (
          currentMetafields[0].meta_value
            ? currentMetafields[0].meta_value
            : ""
        );

      // Reset value if not in options
      // console.log("externalValue: ", externalValue, fieldConfig.options);
      if (!isExternalValueAValidOption(externalValue)) {
        // console.log("externalValue not in options: ", externalValue, fieldConfig.options);
        // console.log("externalValue: ", externalValue);
        externalValue = "";
      }

      return externalValue;
    }
  }

  if (!fieldConfig)
    return null;

  const helperText = hideChannels
    ? null
    : (currentMetafields.map((metafield, i) => channelDisplayNames[metafield.channel] + (i < currentMetafields.length - 1 ? ", " : "")));
  if (labelPosition === "before")
    return (
      <Grid container spacing={2}>
        <Grid item xs={6} md={7} >
          <Typography>
            {fieldConfig.label}
            {
              fieldConfig.description &&
              <InfoTooltip
                content={fieldConfig.description}
              />
            }
          </Typography>
          <Typography variant="caption" color="textSecondary">{helperText}</Typography>
        </Grid>
        <Grid item xs={6} md={5}>
          <Select
            key={currentMetafields[0].id}
            fullWidth
            value={value || value === 0 ? value : fieldConfig.multiple ? [] : ""}
            onChange={(e) => {
              setValue(e.target.value);
            }}
            onBlur={() => {
              // force rerender to make sure placeholders using the value of this field are updated
              setMetafieldsValues(currentMetafields, fieldConfig.multiple ? JSON.stringify(value) : value, true);
            }}
            multiple={fieldConfig.multiple}
          >
            <MenuItem key={currentMetafields[0].id + "-empty"} value="">-</MenuItem>
            {fieldConfig.options.map((option) => {
              if (typeof option === "string" || !isNaN(option))
                return <MenuItem key={option} value={option}>{keyToLabel(option)}</MenuItem>
              else
                return <MenuItem key={option.value} value={option.value}>{resolvePlaceholders(option.label)}</MenuItem>
            })}
          </Select>
        </Grid>
      </Grid>
    );
  // return (
  //   <TextField
  //     key={currentMetafields[0].id}
  //     fullWidth
  //     label={fieldConfig.label}
  //     helperText={helperText}
  //     value={value || value === 0 ? value : ""}
  //     onChange={(e) => {
  //       setValue(e.target.value);
  //     }}
  //     onBlur={() => {
  //       // force rerender to make sure placeholders using the value of this field are updated
  //       setMetafieldsValues(currentMetafields, value, true);
  //     }}
  //     InputLabelProps={{ shrink: true }}
  //     select

  //   >
  //     <MenuItem key={currentMetafields[0].id + "-empty"} value="">-</MenuItem>
  //     {fieldConfig.options.map((option) => {
  //       if (typeof option === "string" || !isNaN(option))
  //         return <MenuItem key={option} value={option}>{keyToLabel(option)}</MenuItem>
  //       else
  //         return <MenuItem key={option.value} value={option.value}>{resolvePlaceholders(option.label)}</MenuItem>
  //     })}
  //   </TextField>
  // );
  return (
    <FormControl style={{ width: "100%" }}>
      <InputLabel>{fieldConfig.label}</InputLabel>
      <Select
        key={currentMetafields[0].id}
        fullWidth
        value={value || value === 0 ? value : fieldConfig.multiple ? [] : ""}
        onChange={(e) => {
          setValue(e.target.value);
        }}
        onBlur={() => {
          // force rerender to make sure placeholders using the value of this field are updated
          setMetafieldsValues(currentMetafields, fieldConfig.multiple ? JSON.stringify(value) : value, true);
        }}
        multiple={fieldConfig.multiple}
      >
        {!fieldConfig.multiple &&
          <MenuItem key={currentMetafields[0].id + "-empty"} value="">-</MenuItem>
        }
        {fieldConfig.options.map((option) => {
          if (typeof option === "string" || !isNaN(option))
            return <MenuItem key={option} value={option}>{keyToLabel(option)}</MenuItem>
          else
            return <MenuItem key={option.value} value={option.value}>{resolvePlaceholders(option.label)}</MenuItem>
        })}
      </Select>
      <FormHelperText>{helperText}</FormHelperText>
    </FormControl>
  )
}
